import React from 'react';
import SiteIcon from './SiteIcon';

/**
 * Üzenet-doboz (a sablon `.callout`-ja): halvány, tónusos alap, színes ikon, világos szöveg.
 * `msg`: { type: 'success' | 'error' | 'info' | 'warn', text }.
 */
const STYLES = {
  success: { box: 'bg-ok/[0.06] border-ok/[0.22]',            icon: 'check', tone: 'text-ok' },
  error:   { box: 'bg-danger/[0.07] border-danger/[0.26]',    icon: 'alert', tone: 'text-danger' },
  info:    { box: 'bg-brand-500/[0.12] border-brand-500/30',  icon: 'info',  tone: 'text-brand-500' },
  warn:    { box: 'bg-warn/[0.06] border-warn/[0.24]',        icon: 'alert', tone: 'text-warn' },
};

export default function AlertMessage({ msg, className = 'mb-6' }) {
  if (!msg) return null;
  const s = STYLES[msg.type] || STYLES.error;

  return (
    <div role={msg.type === 'error' ? 'alert' : 'status'}
         className={`px-4 py-3.5 flex items-start gap-3 rounded-panel border text-sm text-gray-100 ${s.box} ${className}`}>
      <SiteIcon name={s.icon} className={`mt-0.5 w-4 h-4 ${s.tone}`} />
      <span className="leading-[1.55]">{msg.text}</span>
    </div>
  );
}
